import React, { Component } from "react";
import { connect } from "react-redux";
import { Form as RForm, FormGroup, Label, Input, Button} from "reactstrap";
import { isEqual } from 'lodash';
import * as Helpers from '../../../Utilities/Common';
import Permissions from "../../../Utilities/Permissions";
import Actions from "../../../Actions";

class Form extends Component{
    constructor(props){
        super(props);
        this.permissions = new Permissions(props.permissions);
        const { id = false, name = "", company_id = ""} = props.data;
        this.state = { id, name, company_id };
    }

    setField = (endpoint, option, location = 0) => {
        Helpers.setField(endpoint, option, location, (dataObj) => this.setState(() => (dataObj)));
    }

    loadCompanies = () => {
        const { token, companyStore, getCompanies } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(companyStore.query,query)){
            getCompanies(token,query,false);
        }
    }

    componentDidMount = () => {
        const { can } = this.permissions;
        can("post","companies") ? this.loadCompanies() : "";
    }

    save = (event) => {
        event.preventDefault();
        const { persist, token, permissions, id = '' } = this.props;
        persist(token, this.state, permissions, id);
    }

    render = () => {
        const { blockedField } = this.permissions;
        const { companyStore: { companies } } = this.props;
        const { id, name, company_id } = this.state;
        return (
            <RForm>
                    <FormGroup>
                        <Label>
                            Name*
                        </Label>
                        <Input onChange={(value) => this.setField("name",value)} defaultValue={name} />
                    </FormGroup>
                    {!blockedField("company_id","users") ? 
                    <FormGroup>
                        <Label>
                            Company*
                        </Label>                            
                        <Input disabled={!id ? false: true} onChange={(value) => this.setField("company_id",value)} value={company_id} type="select">{ Helpers.dropdownItems(companies) }</Input>                            
                    </FormGroup>
                    : ""}
                    <FormGroup>
                            <Button block onClick={this.save} color="success" kind="squared">Save</Button>                           
                    </FormGroup>
                </RForm>
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    companyStore: state.companyStore,
});

export default connect(mapStateToProps, Actions.companies)(Form);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/Form.js